import React, { useState } from 'react';
import '../../styles/ProjectsGallery.css';
import { Plane, BarChart3, ArrowRight,Coffee, Tv, Hotel ,Martini } from "lucide-react";
import fineDining from '../../assets/Fine Dining Restaurant.jpg';
import ModernBarLounge from '../../assets/Modern Bar & Lounge.jpg';
import Specialitycafe from '../../assets/Specialty Café.jpg';
import cloudkitchen from '../../assets/Cloud Kitchen.jpg';
import hoteloperations from '../../assets/Hotel F&B Operations.jpg';
import multioutlet from '../../assets/Multi-Outlet Chain.jpg';
const ProjectsGallery = () => {
   const [activeCase, setActiveCase] = useState(null);

const handleClick = (caseName) => {
  setActiveCase(caseName);

  const safeId = `case-${caseName.replace(/[^a-zA-Z0-9]/g, "")}`;

  setTimeout(() => {
    const element = document.getElementById(safeId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, 100);
};
  const projects = [
    {
      id: 1,
      image: fineDining,
      title: 'Fine Dining Restaurant',
      caseName: 'Deveras Restaurant'
    },
    {
      id: 2,
      image: ModernBarLounge,
      title: 'Modern Bar & Lounge',
      caseName: 'The Scene — Kitchen & Bar'
    },
    {
      id: 3,
      image: Specialitycafe,
      title: 'Specialty Café',
      caseName: 'Amare — By Love'
    },
    {
      id: 4,
      image: cloudkitchen,
      title: 'Cloud Kitchen',
      caseName: "Adda's Cloud Kitchen"
    },
    {
      id: 5,
      image: hoteloperations,
      title: 'Hotel F&B Operations',
      caseName: 'Porcha Inn Hotel'
    },
    {
      id: 6,
      image: multioutlet,
      title: 'Multi-Outlet Chain',
      caseName: 'Daily Sushis'
    }
  ];
        const cases = [
  {
    name: "Deveras Restaurant",
    icon: <Plane size={18} />,
    details: "Fine dining · South Bengaluru · 80 covers · 14-week engagement",
    tag: "Fine Dining",
    metrics: [
      { value: "↓ 6.8%", label: "Food cost reduction" },
      { value: "₹3.1L", label: "Monthly margin recovered" },
      { value: "↑ 71%", label: "Wastage variance" },
      { value: "Week 3", label: "First results visible" },
    ],
    before: [
      "Food cost at 41% — well above benchmark",
      "No daily P&L — month-end surprises every cycle",
      "Kitchen running on head chef's memory alone",
      "4 dishes with negative contribution margin",
    ],
    after: [
      "Food cost stabilised at 34.2% — held 8 consecutive weeks",
      "Daily P&L live by Week 2. Zero end-of-month shock",
      "Full recipe SOP library. Consistent execution every shift",
      "4 dishes repriced, 2 retired from menu",
    ],
    quote:
      "For the first time in three years, I understood exactly what my restaurant was costing me. That clarity changed how I make every decision.",
    author:  
      "— Founder, Deveras Restaurant (name withheld on request)",
      
  },

  {
    name: "The Scene — Kitchen & Bar",
    icon: <Martini size={18}/>,
    details: "Modern Bar & Lounge · Indiranagar, Bengaluru · 120 covers · 10-week engagement",
    tag: "Bar & Lounge",
    metrics: [
      { value: "↓ 9.2% ", label: "Beverage cost reduction" },
      { value: "₹2.6L", label: "Pour-loss recovered monthly" },
      { value: "↑ 22%", label: "Revenue per cover" },
      { value: "Week 9", label: "Owner's first full weekend off (2 yrs)" },
    ],
    before: [
      "Beverage cost at 38% — benchmark is 22–28%",
      "No pour controls or cocktail recipe cards",
      "Owner present every weekend without exception",
      "Peak-hour collapse every Friday — team improvising",
    ],
    after: [
      "Beverage cost down to 28.8% within 6 weeks",
      "Full cocktail SOP library. Measured pours across all staff",
      "Owner took first full weekend off in 2 years — Week 9",
      "Peak-hour SOP live. Zero service breakdowns in 4 weeks",
    ],
    quote:
      "I was haemorrhaging money behind the bar and had no idea. The pour-cost audit alone paid for the entire engagement in the first month.",
      author:
      "— Co-founder, The Scene Kitchen & Bar (name withheld on request)",
      
  },
  {
    name: "Amare — By Love",
    icon: <Coffee size={24}/>,
    details: "Specialty Café · Koramangala, Bengaluru · 2 locations · 8-week engagement",
    tag: "Specialty Café",
    metrics: [
      { value: "↓ 4.4% ", label: "Food cost reduction" },
      { value: "₹1.4L", label: "Monthly recovered (per location)" },
      { value: "↑ 31%", label: "Menu contribution margin" },
      { value: "64 → 41", label: "Menu items (all now profitable)" },
    ],
    before: [
      "Coffee cost tracking nonexistent — wastage unmonitored",
      "64-item menu with no profitability tracking",
      "Inventory variance at 23% monthly — stock disappearing",
      "Two locations running entirely different systems",
    ],
    after: [
      "Coffee cost per cup tracked daily. Wastage down 78%",
      "Menu rationalised to 41 items. Every item margin-positive",
      "Inventory variance at 4.1%. Cycle counts introduced weekly",
      "Both locations running identical SOPs for the first time",
    ],
    quote:
      "We had 18 menu items that were actually losing us money every time we sold them. We had no idea. The diagnostic showed us in Week 1.",
    author:
      "— Founder, Amare By Love (name withheld on request)",
      
  },
   {
    name: "Adda's Cloud Kitchen",
    icon: <Tv size={24} className="tv-icon"/>,
    details: "Cloud Kitchen · 3 Virtual Brands · Whitefield, Bengaluru · 9-week engagement",
    tag: "Cloud Kitchen",
    metrics: [
      { value: "↓ 4.2%", label: "Food cost reduction" },
      { value: "18% → 4%", label: "Inventory variance" },
      { value: "↑ 19%", label: "Net payout per order" },
      { value: "↓ 61%", label: "Order fulfilment errors" },
    ],
    before: [
      "Food cost at 46% — unsustainable for delivery economics",
      "Inventory variance 18% monthly — no tracking system",
      "3 brands sharing 1 kitchen with zero workflow separation",
      "Aggregator ratings declining due to inconsistent execution",
    ],
    after: [
      "Food cost to 41.8% — held 6 weeks post-engagement",
      "Inventory variance to 4%. Daily cycle counts introduced",
      "3-brand kitchen zoned and mapped. Zero crossover errors",
      "Both platforms above 4.3 stars within 5 weeks",
    ],
    quote:
      "I was doing ₹9L/month in orders and wondering why I had nothing left. Eighteen percent of my inventory was vanishing.",
      author:
      "— Founder, Adda's Cloud Kitchen (name withheld on request)",
      
  },
   {
    name: "Porcha Inn Hotel",
    icon: <Hotel size={24}/>,
    details: "Hotel F&B Operations · Central Bengaluru · All-day dining + rooftop bar + banqueting · 16-week engagement",
    tag: "Hotel F&B",
    metrics: [
      { value: "↓ 7.3% ", label: "Combined F&B cost" },
      { value: "₹5.8L", label: "Monthly margin recovered" },
      { value: "↑ 41%", label: "Banqueting contribution margin" },
      { value: "Week 4", label: "FSSAI compliance restored" },
    ],
    before: [
      "Three F&B outlets operating as complete silos",
      "Banqueting priced on intuition — no costing model",
      "F&B manager was the only person who understood each outlet",
      "FSSAI documentation 14 months out of date",
    ],
    after: [
      "Unified P&L across all 3 outlets. Cross-outlet stock sharing",
      "Full banqueting costing model. Minimum margin floor enforced",
      "Full SOP library. 2 staff onboarded without owner involvement",
      "FSSAI renewed. Compliance calendar system implemented",
    ],
    quote:
      "We had no idea our banqueting was subsidising our restaurant. The margin model showed us exactly where every rupee was going.",
      author:
      "— General Manager, Porcha Inn Hotel (name withheld on request)",
      
  },
  {
    name: "Daily Sushis",
    icon: <BarChart3 size={18} />,
    details: "Multi-outlet QSR · 4 locations · Bengaluru · 18-week engagement",
    tag: "Multi-Outlet Chain",
    metrics: [
      { value: "↓ 5.1%", label: "Avg food cost (all 4 sites)" },
      { value: "₹2.4L", label: "Monthly recovered / location" },
      { value: "4 → 1", label: "Systems unified" },
      { value: "8 Locs", label: "Expansion confirmed" },
    ],
    before: [
      "All 4 locations on entirely different operating systems",
      "No centralised vendor contracts — each outlet buying independently",
      "Founder visiting all 4 locations daily — 70+ hour weeks",
      "No scalable infrastructure for expansion",
    ],
    after: [
      "Single operating system across all 4 — identical execution",
      "Centralised vendor contracts. 11% procurement cost saving",
      "Founder reduced to 2 visits/week. First real holiday in 3 years",
      "Full playbook ready for locations 5–8. Expansion confirmed",
    ],
    quote:
      "I was running four locations and I was the system. Now each runs identically and I'm opening four more without fear.",
      author:
      "— Founder, Daily Sushis (name withheld on request)",
  },
];


  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        <h2 className="section-title">Projects Launched</h2>
        <p className="section-subtitle">
          Six businesses. Real systems. Measurable outcomes. — 
          or use the aggregate stats strip as the entire opener, removing the old text completely.
        </p>

        <div className="projects-grid">
  {projects.map((project) => (
    <div
      key={project.id}
      className="project-card"
      onClick={() => handleClick(project.caseName)}
    >
      <div className="project-image-wrapper">
        <img src={project.image} alt={project.title} />

        <div className="project-overlay">
          <h3>{project.title}</h3>
          <span className="know-more">
            Know More <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </div>
  ))}
</div>
      </div>
      <section className="work-section">
      
      {/* LABEL */}
      

      {/* TITLE */}
      <p className="work-sub">OUR WORK</p>
      <h2 className="work-title">
        Six businesses. Real systems. Measurable outcomes.
      </h2>

      {/* METRICS STRIP */}
      <div className="metrics-strip">
        
        <div className="metric-item">
          <h3>5.8%</h3>
          <p>average food & beverage cost reduction across all 6 engagements</p>
        </div>

        <div className="metric-item">
          <h3>₹2.9L</h3>
          <p>average monthly margin recovered per engagement</p>
        </div>

        <div className="metric-item">
          <h3>6 / 6</h3>
          <p>clients recovered diagnostic investment within 4 weeks of first changes</p>
        </div>

      </div>

    </section>

    <section className="premium-outcome" id="cases-section">
      <div className="containe">
        {/* <span className="eyebro">REAL OUTCOMES</span>
        <h2>What changes when systems are in place</h2> */}

        <div className="gri">
          {cases.map((item, i) => (
            <div
              id={`case-${item.name.replace(/[^a-zA-Z0-9]/g, "")}`}
              key={i}
              className={`cas-car ${
                activeCase === item.name ? "active-case" : ""
              }`}
            >
              
              {/* HEADER */}
              <div className="cas-header">
              <div className="title-ro">
                <div className="logo-bo">
                  {item.icon}
                </div>

                <div>
                  <h3>{item.name}</h3>
                  <p>{item.details}</p>
                </div>
              </div>

              <span className="pil">{item.tag}</span>
            </div>

              {/* METRICS */}
              <div className="metrics-ro">
                {item.metrics.map((m, idx) => (
                  <div key={idx} className="metric-bo">
                    <h4>{m.value}</h4>
                    <span>{m.label}</span>
                  </div>
                ))}
              </div>

              {/* BEFORE AFTER */}
              <div className="before-afte">
                <div className="bo">
                  <span className="labe">BEFORE</span>
                  <ul>
                    {item.before.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </div>

                <div className="arro">→</div>

                <div className="bo">
                  <span className="labe">AFTER</span>
                  <ul>
                    {item.after.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* QUOTE */}
              <div className="quote-bo">
                <p className="quote-text">"{item.quote}"</p>
  <span className="quote-author">{item.author}</span>
              </div>
            </div>
          ))}
        </div>
        </div>
    </section>
    </section>
  );
};
export default ProjectsGallery;